import { t } from '@lingui/macro'
import { useState } from 'react'
import styled, { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { StObservationItem } from '@/modules/shared/components/observation-item/ObservationItem'

type StructuredObservationChoiceProps = {
  questionId: string
  emptyMessage: string
  addLabel: string
  noneLabel: string
  onAdd: () => void
  onConfirmNone: () => void
}

export const StructuredObservationChoice = ({
  questionId,
  emptyMessage,
  addLabel,
  noneLabel,
  onAdd,
  onConfirmNone,
}: StructuredObservationChoiceProps) => {
  const theme = useTheme()
  const [choice, setChoice] = useState<'add' | 'none' | null>(null)

  const handleNext = () => {
    if (choice === 'add') {
      onAdd()
    } else {
      onConfirmNone()
    }
  }

  return (
    <FlexColumn gap={theme.UI.Spacing.Space3}>
      <StObservationItem type='BodyMediumRegular'>{emptyMessage}</StObservationItem>

      <StChoiceOption htmlFor={`${questionId}_add`}>
        <input
          type='radio'
          id={`${questionId}_add`}
          name={`${questionId}_scheme_choice`}
          checked={choice === 'add'}
          onChange={() => setChoice('add')}
        />
        <FlexColumn>
          <span>{addLabel}</span>
        </FlexColumn>
      </StChoiceOption>

      <StChoiceOption htmlFor={`${questionId}_none`}>
        <input
          type='radio'
          id={`${questionId}_none`}
          name={`${questionId}_scheme_choice`}
          checked={choice === 'none'}
          onChange={() => setChoice('none')}
        />
        <FlexColumn>
          <span>{noneLabel}</span>
        </FlexColumn>
      </StChoiceOption>

      <Button type='button' variant='Primary' onClick={handleNext} disabled={choice === null}>
        {t({
          id: 'globals.continue',
          comment: 'Global for continue',
          message: 'Ga verder',
        })}
      </Button>
    </FlexColumn>
  )
}

// ================================ Styled Components ================================

const StChoiceOption = styled.label`
  &:hover {
    cursor: pointer;

    > div {
      transition-property: border, background, color;
      transition-duration: 175ms;
      background-color: ${({ theme }) => theme.Components.Conversational.ActiveFill};
      color: ${({ theme }) => theme.Components.Conversational.ActiveText};
    }
  }

  > input {
    display: none;
  }

  > div {
    border: 1px solid ${({ theme }) => theme.Components.Conversational.Border};
    border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
    background-color: ${({ theme }) => theme.Components.Conversational.Fill};
    color: ${({ theme }) => theme.Components.Conversational.Text};
    padding: ${({ theme }) => `${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space4}`};
    transition: all 175ms ease-out;
  }

  input:checked + div {
    border-color: ${({ theme }) => theme.Components.Conversational.ActiveBorder};
    background-color: ${({ theme }) => theme.Components.Conversational.ActiveFill};
    color: ${({ theme }) => theme.Components.Conversational.ActiveText};
  }
`
